export default function VisionMission() {
  return (
    <section className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <span className="text-sm font-medium text-[#0F766E] mb-4 block">비전</span>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-6">
              기술로 연결하는<br />
              더 나은 미래
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              AI와 데이터 기술을 통해 공공과 기업의 디지털 전환을 지원하고,
              실질적인 가치를 창출하는 기술 파트너가 되겠습니다.
              연구개발 역량을 바탕으로 지속 가능한 혁신을 만들어갑니다.
            </p>
          </div>

          <div>
            <span className="text-sm font-medium text-[#0F766E] mb-4 block">미션</span>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-6">
              문제 해결 중심의<br />
              기술 구현
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-sm text-[#0D9488]"></i>
                </div>
                <p className="text-sm text-gray-600">
                  고객의 실질적인 문제를 이해하고 최적의 기술 솔루션 제공
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-sm text-[#0D9488]"></i>
                </div>
                <p className="text-sm text-gray-600">
                  연구개발 기반의 검증된 기술로 안정적인 시스템 구축
                </p>
              </div>
              <div className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-sm text-[#0D9488]"></i>
                </div>
                <p className="text-sm text-gray-600">
                  지속적인 기술 혁신과 고객 성공을 위한 파트너십 구축
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
